export default __webpack_public_path__ + "static/media/Dean.2c8bcaa3.png";